module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_resort_sola@3x-d0ddbbcf35774c76b0c6eea28ec1fa69.webp";